<template>
<svg class="w-7 h-7" viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg">
  <path d="M912 1696q0-16-16-16-59 0-101.5-42.5t-42.5-101.5q0-16-16-16t-16 16q0 73 51.5 124.5t124.5 51.5q16 0 16-16zm-666-288h1300q-266-300-266-832 0-51-24-105t-69-103-121.5-80.5-169.5-31.5-169.5 31.5-121.5 80.5-69 103-24 105q0 532-266 832zm1482 0q0 52-38 90t-90 38h-448q0 106-75 181t-181 75-181-75-75-181h-448q-52 0-90-38t-38-90q50-42 91-88t85-119.5 74.5-158.5 50-206 19.5-260q0-152 117-282.5t307-158.5q-8-19-8-39 0-40 28-68t68-28 68 28 28 68q0 20-8 39 190 28 307 158.5t117 282.5q0 139 19.5 260t50 206 74.5 158.5 85 119.5 91 88z"/>
  </svg>
</template>

<script>
export default {
  name: 'BellIcon',
}
</script>

<style lang="scss" scoped>
path {
	fill: #fff;
}

</style>



// WEBPACK FOOTER //
// BellIcon.vue?b4522688